import { ReactElement, ReactNode, useState } from "react"
import { useParams } from "react-router-dom"
import { v4 as uuid4 } from "uuid"

import CreateEbDeviceProvider from "./baseProviders/createEbDeviceProvider"
import useStartNewEbDeviceVersion from "../../../../../services/middleware/hooks/devices/lct/useStartNewEbDeviceVersion"

interface INewEbDeviceVersionFormUrlParams {
    deviceRef: string
}

interface INewEbDeviceVersionProviderProps {
    children: ReactNode
}

const NewEbDeviceVersionProvider = ({
    children,
}: INewEbDeviceVersionProviderProps): ReactElement => {
    const { deviceRef: urlDeviceRef } = useParams<
        keyof INewEbDeviceVersionFormUrlParams
    >() as INewEbDeviceVersionFormUrlParams

    const [attachmentUUID] = useState<string>(uuid4())

    const {
        data: formData,
        setData: setFormData,
        isLoading,
        error: newEbDeviceVersionError,
        apiResSystemRef: systemReference,
    } = useStartNewEbDeviceVersion(urlDeviceRef, attachmentUUID)

    return (
        <CreateEbDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={isLoading}
            formDataError={newEbDeviceVersionError}
            attachmentUUID={attachmentUUID}
            systemReference={systemReference ?? ""}
            canEditManufacturer={false}
        >
            {children}
        </CreateEbDeviceProvider>
    )
}

export default NewEbDeviceVersionProvider
